import { motion } from "framer-motion";
import { ATTRACTIONS } from "../../data/project";

export default function IslandLifestyle() {
  return (
    <section
      id="lifestyle"
      data-testid="lifestyle-section"
      className="relative bg-[#F4F2EC] py-24 md:py-36 border-t hairline"
    >
      <div className="max-w-[1440px] mx-auto px-6 md:px-12">
        <div className="grid grid-cols-12 gap-8 items-end mb-14 md:mb-20">
          <div className="col-span-12 md:col-span-7">
            <div className="overline mb-5">Beyond the Home</div>
            <h2
              className="font-serif leading-[1.02] tracking-tight text-[#1A3626]"
              style={{ fontSize: "clamp(40px, 5.5vw, 78px)" }}
            >
              Life on
              <br />
              <span className="italic font-light">Hudayriyat.</span>
            </h2>
          </div>
          <div className="col-span-12 md:col-span-5">
            <p className="text-[#1A3626]/75 font-light leading-relaxed">
              Hudayriyat is Abu Dhabi's leading leisure and sports island.
              The world's largest wave pool, Olympic-scale sports campuses,
              waterfront dining, beach clubs and beachside glamping, all
              twenty minutes from your front door.
            </p>
          </div>
        </div>

        {/* Bento grid of attractions */}
        <div className="grid grid-cols-12 gap-4 md:gap-6">
          {ATTRACTIONS.map((a, i) => {
            // Bento layout: big-small-small / small-big-small etc.
            const layouts = [
              "col-span-12 md:col-span-7 aspect-[16/10]",
              "col-span-12 md:col-span-5 aspect-[5/4] md:aspect-auto",
              "col-span-6 md:col-span-4 aspect-[4/5]",
              "col-span-6 md:col-span-4 aspect-[4/5]",
              "col-span-12 md:col-span-4 aspect-[4/5]",
              "col-span-12 md:col-span-7 aspect-[16/10]",
              "col-span-6 md:col-span-5 aspect-[4/5] md:aspect-auto",
              "col-span-6 md:col-span-12 aspect-[4/5] md:aspect-[16/6]",
            ];
            return (
              <motion.figure
                key={a.name}
                data-testid={`attraction-${i}`}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-80px" }}
                transition={{ duration: 0.8, delay: i * 0.05 }}
                className={`relative overflow-hidden group bg-[#1A3626] ${layouts[i]}`}
              >
                <img
                  src={a.url}
                  alt={a.name}
                  className="absolute inset-0 w-full h-full object-cover transition-transform [transition-duration:1600ms] ease-out group-hover:scale-[1.05]"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#1A3626]/85 via-[#1A3626]/15 to-transparent" />
                <figcaption className="absolute bottom-0 left-0 right-0 p-5 md:p-7 text-[#F4F2EC]">
                  <div
                    className="text-[10px] tracking-[0.28em] uppercase mb-2"
                    style={{ color: "#B3906A" }}
                  >
                    Attraction {String(i + 1).padStart(2, "0")}
                  </div>
                  <div className="font-serif text-2xl md:text-3xl leading-tight">
                    {a.name}
                  </div>
                  <p className="mt-2 text-sm text-[#F4F2EC]/80 font-light leading-relaxed max-w-md hidden md:block">
                    {a.body}
                  </p>
                </figcaption>
              </motion.figure>
            );
          })}
        </div>

        <p className="mt-10 text-xs text-[#6A736E] font-light max-w-3xl leading-relaxed">
          Imagery courtesy of Modon / Hudayriyat Island. All attractions
          accessible by car, bike, or shuttle from the Golf Estates community.
        </p>
      </div>
    </section>
  );
}
